import axios from 'axios';
window.Handbook = window.Handbook || {}
axios.defaults.baseURL = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";

export default {
    ApiUri: window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/",
    AphUrl: window.Handbook.AphUrl || "https://www.aph.gov.au",
    LibraryUrl: (window.Handbook.AphUrl ? `${window.Handbook.AphUrl}/library` : "https://www.aph.gov.au/library"),
    HandbookUrl: window.Handbook.HandbookUrl || "http://localhost:8080",
    Debug: window.Handbook.Debug,
    AnalyticsId: window.Handbook.AnalyticsId || "UA-175550706-1",
    // doesn't necessarily mean actual production - just used for feature flagging.
    Production: window.Handbook.ApiUri === 'https://handbookapi.aph.gov.au/' 
    || window.Handbook.ApiUri === 'https://testhandbookapi.aph.gov.au/' 
    || window.Handbook.ApiUri === 'https://localhandbookapi.aph.gov.au/'
    || window.Handbook.ApiUri === 'http://localhandbookapi.aph.gov.au/',
    // actual prod
    RealProduction: window.Handbook.ApiUri === 'https://handbookapi.aph.gov.au/',

    // renamed:
    CURL_PARLIAMENTS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_PARLIAMENTS = data
                    resolve({ OBJ_PARLIAMENTS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_PARTIES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_PARTIES = data
                    resolve({ OBJ_PARTIES });
                })
                .catch((err) => {
                    var reason = new Error(`Error Fetching ${err}`);
                    reject(reason); // reject        
                });
        });
    },

    CURL_ELECTORATES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_ELECTORATES = data
                    resolve({ OBJ_ELECTORATES });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_STATES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_STATES = data
                    resolve({ OBJ_STATES });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_PARLIAMENTARIANS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_PARLIAMENTARIANS = data
                    resolve({ OBJ_PARLIAMENTARIANS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_RECORDSOFSERVICE(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_RECORDSOFSERVICE = data
                    resolve({ OBJ_RECORDSOFSERVICE });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_MINISTRIES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_MINISTRIES = data
                    resolve({ OBJ_MINISTRIES });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_COMMITTEES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_COMMITTEES = data
                    resolve({ OBJ_COMMITTEES });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_MINISTRYSTATS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_MINISTRYSTATS = data
                    resolve({ OBJ_MINISTRYSTATS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_SHADOWMINISTRYSTATS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_SHADOWMINISTRYSTATS = data
                    resolve({ OBJ_SHADOWMINISTRYSTATS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_REFERENDUMS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_REFERENDUMS = data
                    resolve({ OBJ_REFERENDUMS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },
    
    CURL_MINISTRYRECORDS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_MINISTRYRECORDS = data
                    resolve({ OBJ_MINISTRYRECORDS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_SHADOWMINISTRIES(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_SHADOWMINISTRIES = data
                    resolve({ OBJ_SHADOWMINISTRIES });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_SHADOWMINISTRYRECORDS(url) {
        return new Promise((resolve, reject) => {
            axios.get(`api/${url}`)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_SHADOWMINISTRYRECORDS = data
                    resolve({ OBJ_SHADOWMINISTRYRECORDS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    },

    CURL_DISTRIBUTIONS(url) {
        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => response.data.value)
                .then(function (data) {
                    let OBJ_DISTRIBUTIONS = data
                    resolve({ OBJ_DISTRIBUTIONS });
                })
                .catch((err) => {
                    reject(`Error Fetching ${err}`);
                });
        });
    }

}


